import React from 'react'
import StyledLogo from './Styled';

export default () => {
    return(
        <StyledLogo>
            <img src="/imgs/triLogo.png" alt="Logo Spinning" className="spinning-logo"/>
        </StyledLogo>
    )
}